
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RegistroIngSalCodPublComponent } from './registro-ing-sal-cod-publ.component';
import { RegistroIngSalCodPublRoutingModule } from './registro-ing-sal-cod-pbl-routing.module';


@NgModule({
  declarations: [RegistroIngSalCodPublComponent],
  imports: [
    SharedModule,
    CommonModule,
    RegistroIngSalCodPublRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RegistroIngSalCodigoModule { }
